export default __webpack_public_path__ + "static/media/wavax.deaeb26e.png";